import {
  renderRequiredRule,
  renderValidator,
  renderLengthFieldRule,
  checkValidityInn,
} from "@/utils/renderRulesForm";

export default () => ({
  cityTo: [renderRequiredRule("Пожалуйста выберите город", 'change')],
  consigneeType: [],
  innConsignee: [
    renderRequiredRule("Пожалуйста введите ИНН"),
    renderValidator({
      validatorFunc: checkValidityInn,
      message: "Некорректно введён ИНН",
    }),
    renderLengthFieldRule({
      min: 10,
      max: 12,
      message: "ИНН должен состоять от 10 до 12 символов",
    }),
  ],
  name: [
    renderRequiredRule("Пожалуйста введите название организации"),
  ],
  surnameConsignee: [
    renderRequiredRule("Введите фамилию"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  firstNameConsignee: [
    renderRequiredRule("Введите имя"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  secondNameConsignee: [
    renderRequiredRule("Введите отчество"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  phoneConsignee: [
    renderRequiredRule("Введите телефон"),
    renderValidator({
      validatorFunc: (value) =>
        !!value.match(/^\+{0,1}\d \([3,4,6-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: "Некорректно введён номер",
    }),
  ],
  emailConsignee: [
    {
      validator: (rule, value, callback) => {
        if (
          (!(value === "") &&
            !value.match(
                /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/
              )) 
        ) {
          callback(new Error("Пожалуйста введите почту"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
});
